/**
 * created by tian ruo jun
 状态和颜色对应关系
 *
 */

const colors = {
    "finishColor": "#87d166",
    "processColor": "#cc77ff",
    "errColor": "#f56c6c",
    "delColor": "#CCC",
    "rescindColor":"rgb(203, 203, 203)",
    "loseColor":"rgb(234, 103, 103)"
};

const colorByState = {
    "发布": colors["finishColor"],
    "提交": colors["processColor"],
    "留用": colors["processColor"],
    "返回": colors["errColor"],
    "撤稿": colors["delColor"],
    "弃用": colors["delColor"],
    "草稿": colors["delColor"],
    "放弃": colors["delColor"],
    "失败":colors["errColor"],
    "已采用":colors["finishColor"],
    "已弃用":colors["delColor"],
    "已拒绝": colors["delColor"],
    "已领取": colors["processColor"],
    "已回稿": colors["finishColor"],
    "未领取":colors["errColor"],
    "进行中":colors["processColor"],
    "已完成":colors["finishColor"],
    "成功":colors["finishColor"],
    "已删除":colors["delColor"],
    "撤回":colors['delColor'],
    "已发布": colors['finishColor'],
};

export const getColorByState = (state) => {
    let color = colors["processColor"];
    if(!state || typeof state !== "string") return color;
    for (var key in colorByState) {
        if (state.indexOf(key) > -1) {
            color = colorByState[key]
        }
    }
    return color;
};
